import { PaymentHistoryLog } from "./PaymentHistoryLog";

export class DTOBase{
    paymentHistoryLog: PaymentHistoryLog
}


// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/common/models/Dtobase.ts